import React, { useEffect, useState } from "react";
import Scrollspy from "react-scrollspy";
import logo from "../assets/layout/images/amie_logo_white.png";

const Navbar = ({ detail = false }) => {
  const [open, setOpen] = useState(false); // (모바일) 메뉴 열림/닫힘
  const [on, setOn] = useState(detail);    // 상세 페이지면 처음부터 on

  // 상세 페이지가 아니면 스크롤에 따라 on 제어
  useEffect(() => {
    if (detail) return;
    const handle = () => setOn(window.scrollY > 120);
    handle();
    window.addEventListener("scroll", handle, { passive: true });
    return () => window.removeEventListener("scroll", handle);
  }, [detail]);

  // 랜딩 안에서 섹션 스크롤 이동
  const smoothTo = (e) => {
    e.preventDefault();
    const hash = e.currentTarget.getAttribute("href");
    const target = document.querySelector(hash);
    if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
  };

  return (
    <header className={`header header-nav ${on ? "on" : "logo-only"}`}>
      <nav className="navbar navbar-expand-lg bg-transparent">
        <div className="container-fluid">
          {/* 로고: 상세 페이지면 루트로 이동, 랜딩이면 스무스 스크롤 */}
          <a
            className="navbar-brand me-2"
            href={detail ? "/#home" : "#home"}
            onClick={detail ? undefined : smoothTo}
          >
            <img
              src={logo}
              alt="AMIESOFT"
              className="d-inline-block align-text-middle"
              style={{
                width: "clamp(100px, 10vw, 160px)",
                height: "auto",
                filter: "drop-shadow(0 1px 2px rgba(0,0,0,.35))",
              }}
            />
          </a>

          {/* 모바일 토글 */}
          <button
            className="navbar-toggler p-1"
            type="button"
            aria-controls="navbarNav"
            aria-expanded={open}
            aria-label="Toggle navigation"
            onClick={() => setOpen((v) => !v)}
          >
            <span className={open ? "bi bi-x-lg p-2" : "bi bi-list p-2"} />
          </button>

          {/* 메뉴 */}
          <div
            id="navbarNav"
            className={
              "collapse navbar-collapse justify-content-center" +
              (open ? " show" : "")
            }
          >
            {detail ? (
              // ✅ 상세 페이지: Business를 강제 활성화
              <ul className="nav navbar-nav mx-auto gap-5">
                <li className="nav-item">
                  <a className="nav-link" href="/#home">Home</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/#intro">About</a>
                </li>
                <li className="nav-item active">
                  <a className="nav-link" href="/#project">Business</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/#contact">Contact Us</a>
                </li>
              </ul>
            ) : (
              // 랜딩 페이지: Scrollspy로 섹션 활성화
              <Scrollspy
                items={["home", "intro", "project", "contact"]}
                currentClassName="active"
                className="nav navbar-nav mx-auto gap-5"
                offset={-120}
              >
                <li className="nav-item">
                  <a className="nav-link" href="#home" onClick={smoothTo}>Home</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#intro" onClick={smoothTo}>About</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#project" onClick={smoothTo}>Business</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#contact" onClick={smoothTo}>Contact Us</a>
                </li>
              </Scrollspy>
            )}
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
